<router-outlet></router-outlet>
<footer class="text-center">
  <a class="m-r-8" href="/data-privacy">{{ 'footer.privacy' | translate }}</a>
  <a href="https://www.pasm.de/index.php/impressum/">{{ 'footer.imprint' | translate }}</a>
</footer>
